export default "/images/edit-2.svg?015e804497d2bef5ca19a5b5ad6a22fc";